import(/* webpackMode: "eager" */ "/app/apps/rooms/src/app/global-error.tsx");
